export function getColorRgb(code: string, alpha?: number): string {
  let rgb;

  if (code) {
    if (!alpha) {
      rgb = `rgb(${code})`;
    } else {
      rgb = `rgba(${code}, ${alpha})`;
    }
  }

  if (!rgb) {
    throw new Error('Could not determine color code');
  }

  return rgb;
}

export function getColorContrastRgb(code: string, alpha?: number): string {
  if (code) {
    let vals: string[] = code.split(',');
    if (vals && vals.length >= 3) {
      let red: number = +vals[0];
      let green: number = +vals[1];
      let blue: number = +vals[2];
      var sum = Math.round((red * 299 + green * 587 + blue * 114) / 1000);
      return sum > 128 ? getColorRgb('0,0,0', alpha) : getColorRgb('255,255,255', alpha);
    }
  }
  return getColorRgb('255,255,255', alpha);
}

//Calculates RGB value after alpha has been applied from RGBA
export function rgbaToRgb(colorRGBA: string, bgColorRGB: string = '0,0,0'): string {
  const colorStrings = colorRGBA.split(',');
  const bgColorStrings = bgColorRGB.split(',');

  if (colorStrings.length != 4 || bgColorStrings.length != 3) return colorRGBA;

  const colorValues = colorStrings.map(colorCode => parseFloat(colorCode));
  const bgColorValues = bgColorStrings.map(colorCode => parseFloat(colorCode));
  //Formula for new color code (red for example) :  (1 - alpha) * bg.red) + (alpha * color.red)
  const red = Math.round((1 - colorValues[3]) * bgColorValues[0] + colorValues[3] * colorValues[0]);
  const green = Math.round(
    (1 - colorValues[3]) * bgColorValues[1] + colorValues[3] * colorValues[1]
  );
  const blue = Math.round(
    (1 - colorValues[3]) * bgColorValues[2] + colorValues[3] * colorValues[2]
  );

  return red.toString() + ',' + green.toString() + ',' + blue.toString();
}

//format strings that come in as 'rgb(r,g,b)' or 'rgba(r,g,b,a)' into 'r,g,b,a'
export function trimColorCode(colorCode: string): string {
  if (colorCode.includes('(')) {
    colorCode = colorCode.substring(colorCode.indexOf('(') + 1, colorCode.length - 1);
  }
  return colorCode;
}
